import { ref } from 'vue';

export function usePageLoading() {
  const loading = ref(false);

  function showLoading() {
    loading.value = true;
  }
  function hideLoading() {
    loading.value = false;
  }

  return {
    loading,
    showLoading,
    hideLoading,
  };
}
